<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="8" v-if="ordersReason">
            <h4 id="traffic" class="card-title mb-0">Eventos</h4>
            <div class="small text-muted">
              <b>{{ordersReason.reference}} - {{ordersReason.name}}</b> — rango de fechas para cargar pedidos,
              % para comisiones y clientes habilitados. Es interno, no se informa a Promob.
            </div>
          </b-col>
          <b-col sm="4">
            <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right" v-b-tooltip.hover title="Agregar Evento">
              <i class="fa fa-plus"></i> Agregar
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-table class="mb-0"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :items="events"
                    :fields="fields"
                    v-if="events.length">

              <template v-slot:cell(name)="data">
                <b>{{data.item.name}}</b>
                <div class="small text-muted" v-if="data.item.observations">{{data.item.observations}}</div>
              </template>

              <template v-slot:cell(rango)="data">
                {{formatearFecha(data.item.date_start)}} al {{formatearFecha(data.item.date_end)}}
              </template>

              <template v-slot:cell(commission_percentage)="data">
                {{parseFloat(data.item.commission_percentage)}} %
              </template>

              <template v-slot:cell(clientes)="data">
                <b-badge variant="info" v-if="data.item.available_all_customers">Todos los del motivo</b-badge>
                <b-badge variant="secondary"
                         v-else
                         style="cursor: pointer"
                         title="Ver clientes"
                         @click="verClientes(data)">
                  {{data.item.event_customers_count}} cliente(s) <i :class="data.detailsShowing ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                </b-badge>
              </template>

              <!-- Clientes del evento, solo lectura (se cargan al desplegar) -->
              <template v-slot:row-details="data">
                <div class="small px-2 py-1">
                  <div v-if="!detalleClientes[data.item.id]" class="text-muted">Cargando...</div>
                  <div v-else-if="!detalleClientes[data.item.id].length" class="text-muted">Sin clientes habilitados</div>
                  <b-row v-else>
                    <b-col md="4" v-for="cliente in detalleClientes[data.item.id]" :key="cliente.id">
                      {{cliente.nombre}}
                      <span class="text-muted" v-if="cliente.grupo">({{cliente.grupo}})</span>
                    </b-col>
                  </b-row>
                </div>
              </template>

              <template v-slot:cell(estado)="data">
                <b-badge :variant="estado(data.item).variant">{{estado(data.item).texto}}</b-badge>
              </template>

              <template v-slot:cell(f_action)="data">
                <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">
                  <b-dropdown-item @click="openClientes(data.item)" v-if="!data.item.available_all_customers">
                    <i class="fa fa-users"></i> Clientes Habilitados
                  </b-dropdown-item>
                  <b-dropdown-header>Acciones</b-dropdown-header>
                  <b-dropdown-item @click="edit(data.item)">
                    <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                  </b-dropdown-item>
                  <b-dropdown-item @click="remove(data.item)">
                    <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <div v-else><b-alert variant="warning" show>Este motivo todavía no tiene eventos</b-alert></div>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD EVENTO -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white">
        <div slot="modal-header">
          {{modal.form.title}}
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Nombre" description="Ej: Hot Sale 2026">
              <b-form-input type="text" size="sm" v-model="crud.form.name" placeholder="Nombre del evento"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Desde">
              <b-form-input type="date" size="sm" v-model="crud.form.date_start"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Hasta" description="Inclusive">
              <b-form-input type="date" size="sm" v-model="crud.form.date_end"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="% Comisión">
              <b-form-input type="number" size="sm" min="0" max="100" step="0.01" v-model="crud.form.commission_percentage"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Estado">
              <b-form-checkbox v-model="crud.form.active" switch>Activo</b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group description="Si no se marca, hay que elegir a mano qué clientes lo tienen (Acción → Clientes Habilitados)">
              <b-form-checkbox v-model="crud.form.available_all_customers">
                Habilitado para todos los clientes que tienen este motivo
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Observaciones">
              <b-form-textarea v-model="crud.form.observations" rows="2" size="sm"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>
        </div>
      </b-modal>

      <!-- CLIENTES DEL EVENTO -->
      <b-modal v-model="modal.clientes.active"
              size="lg"
              header-bg-variant="dark"
              header-text-variant="white">
        <div slot="modal-header">
          Clientes Habilitados — {{modal.clientes.event ? modal.clientes.event.name : ''}}
        </div>

        <!-- Motivo para todos los clientes: se busca cualquier cliente -->
        <div v-if="ordersReason && ordersReason.available_all_customers" class="mb-2">
          <FindObject render="search"
                      type="customers"
                      @select-object="agregarCliente($event)"
                      :valueID="0"
                      :key="componentKey" />
        </div>
        <!-- Motivo con clientes puntuales: se elige entre los que tienen el motivo -->
        <div v-else class="small text-muted mb-2">
          Solo se listan los clientes que tienen habilitado el motivo <b>{{ordersReason ? ordersReason.name : ''}}</b>.
        </div>

        <!-- Grupo de clientes: marca de una vez a todos los clientes del grupo -->
        <b-row class="mb-2">
          <b-col md="8">
            <b-form-select v-model="modal.clientes.grupoID" :options="opcionesGrupos" size="sm"></b-form-select>
          </b-col>
          <b-col md="4" class="text-right">
            <b-button size="sm" variant="outline-dark" :disabled="!modal.clientes.grupoID" @click="marcarGrupo()">Marcar grupo</b-button>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="8">
            <b-form-input v-model="modal.clientes.filtro" placeholder="Buscar en la lista..." size="sm"></b-form-input>
          </b-col>
          <b-col md="4" class="text-right" v-if="!(ordersReason && ordersReason.available_all_customers)">
            <b-button size="sm" variant="outline-dark" class="mr-1" @click="marcarTodos(true)">Todos</b-button>
            <b-button size="sm" variant="outline-dark" @click="marcarTodos(false)">Ninguno</b-button>
          </b-col>
        </b-row>

        <div class="small mb-1"><b>{{clientesMarcados.length}}</b> cliente(s) habilitado(s)</div>

        <div style="max-height: 400px; overflow-y: auto">
          <b-form-checkbox v-for="cliente in clientesFiltrados"
                           :key="cliente.id"
                           v-model="cliente.marcado"
                           class="mb-1">
            {{cliente.nombre}}
          </b-form-checkbox>
          <b-alert v-if="!clientesFiltrados.length" variant="warning" show>Sin clientes para mostrar</b-alert>
        </div>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.clientes.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveClientes()">Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'

  export default {
    components: {
      FindObject,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudOrdersReasonEvents',
          elements: {}
        },
        fields: [
          {key: 'name', label: 'Evento', class: 'align-middle'},
          {key: 'rango', label: 'Vigencia', class: 'align-middle'},
          {key: 'commission_percentage', label: '% Comisión', class: 'align-middle'},
          {key: 'clientes', label: 'Clientes', class: 'align-middle'},
          {key: 'estado', label: 'Estado', class: 'align-middle'},
          {key: 'f_action', label: '', class: 'align-middle'},
        ],
        ordersReasonID: 0,
        ordersReason: null,
        events: [],
        grupos: [],
        detalleClientes: {},
        crud: {
          form: {},
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          clientes: {
            active: false,
            event: null,
            filtro: '',
            lista: [],
            grupoID: null,
          },
        },
        componentKey: 0,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.ordersReasonID = this.$route.params.reasonID
      this.loadOrdersReason()
      this.load()
      this.loadGrupos()
    },
    computed: {
      clientesFiltrados() {
        var texto = this.modal.clientes.filtro.trim().toLowerCase()
        if(!texto) {
          return this.modal.clientes.lista
        }
        return this.modal.clientes.lista.filter(c => c.nombre.toLowerCase().indexOf(texto) !== -1)
      },
      clientesMarcados() {
        return this.modal.clientes.lista.filter(c => c.marcado)
      },
      opcionesGrupos() {
        var opciones = [{ value: null, text: 'Grupo de clientes...' }]
        this.grupos.filter(g => g.active).forEach(g => opciones.push({ value: g.id, text: g.name }))
        return opciones
      },
    },
    methods: {
      loadOrdersReason() {
        serviceAPI.mostrarMotivos(this.ordersReasonID)
        .then((response) => {
          this.ordersReason = response.data
        })
      },
      loadGrupos() {
        serviceAPI.obtenerGruposClientes()
        .then((response) => {
          this.grupos = response.data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      load() {
        this.detalleClientes = {}
        let loader = this.$loading.show();
        serviceAPI.obtenerEventosPorMotivo(this.ordersReasonID)
        .then((response) => {
          this.events = response.data
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      hoy() {
        var d = new Date()
        var mes = ('0' + (d.getMonth() + 1)).slice(-2)
        var dia = ('0' + d.getDate()).slice(-2)
        return d.getFullYear() + '-' + mes + '-' + dia
      },
      formatearFecha(fecha) {
        if(!fecha) {
          return ''
        }
        var partes = fecha.substring(0, 10).split('-')
        return partes[2] + '/' + partes[1] + '/' + partes[0]
      },
      estado(item) {
        if(!item.active) {
          return { texto: 'Inactivo', variant: 'secondary' }
        }
        var hoy = this.hoy()
        if(hoy < item.date_start) {
          return { texto: 'Próximo', variant: 'info' }
        }
        if(hoy > item.date_end) {
          return { texto: 'Finalizado', variant: 'dark' }
        }
        return { texto: 'Vigente', variant: 'success' }
      },
      add() {
        this.crud.form = {
          id: 0,
          name: '',
          date_start: this.hoy(),
          date_end: this.hoy(),
          commission_percentage: 0,
          available_all_customers: false,
          active: true,
          observations: '',
        }
        this.modal.form.title = 'Nuevo Evento'
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form = {
          id: item.id,
          name: item.name,
          date_start: item.date_start,
          date_end: item.date_end,
          commission_percentage: parseFloat(item.commission_percentage),
          available_all_customers: !!item.available_all_customers,
          active: !!item.active,
          observations: item.observations || '',
        }
        this.modal.form.title = 'Editar Evento'
        this.modal.form.active = true
      },
      save() {
        let loader = this.$loading.show();
        var data = Object.assign({}, this.crud.form, { reason_id: this.ordersReasonID })
        var result = data.id ? serviceAPI.editarEvento(data) : serviceAPI.agregarEvento(data)

        result.then((response) => {
          loader.hide()
          this.modal.form.active = false
          this.$awn.success("Datos guardados con éxito");
          this.load()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      remove(item) {
        this.$bvModal.msgBoxConfirm('¿Desea borrar el evento "' + item.name + '"?', {
          title: 'Borrar Evento',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if(value) {
            let loader = this.$loading.show();
            serviceAPI.eliminarEvento(item.id)
            .then(() => {
              loader.hide()
              this.$awn.success("Registro eliminado");
              this.load()
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
      },
      nombreCliente(customer, customersID) {
        if(!customer) {
          return 'Cliente #' + customersID
        }
        return customer.code ? customer.code + ' | ' + customer.name : customer.name
      },
      // Motivo con clientes puntuales: lista = clientes del motivo, marcados los del evento.
      // Motivo para todos: lista = solo los del evento (se agregan con el buscador).
      openClientes(event) {
        this.modal.clientes.event = event
        this.modal.clientes.filtro = ''
        this.modal.clientes.lista = []
        this.modal.clientes.grupoID = null

        let loader = this.$loading.show();
        var delEvento = serviceAPI.obtenerClientesPorEvento(event.id)
        var delMotivo = this.ordersReason.available_all_customers
          ? Promise.resolve({ data: [] })
          : serviceAPI.obtenerClientesPorMotivo(this.ordersReasonID)

        Promise.all([delEvento, delMotivo])
        .then(([respEvento, respMotivo]) => {
          var marcados = {}
          respEvento.data.forEach(item => {
            marcados[item.customers_id] = this.nombreCliente(item.customer, item.customers_id)
          })

          var lista = []
          if(this.ordersReason.available_all_customers) {
            Object.keys(marcados).forEach(id => lista.push({ id: parseInt(id), nombre: marcados[id], marcado: true }))
          } else {
            respMotivo.data.forEach(item => {
              lista.push({
                id: item.customers_id,
                nombre: this.nombreCliente(item.customer, item.customers_id),
                marcado: !!marcados[item.customers_id],
              })
            })
          }
          lista.sort((a, b) => a.nombre.localeCompare(b.nombre))

          this.modal.clientes.lista = lista
          this.modal.clientes.active = true
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      agregarCliente(object) {
        if(!object) {
          return
        }
        var existente = this.modal.clientes.lista.find(c => c.id == object.id)
        if(existente) {
          existente.marcado = true
        } else {
          this.modal.clientes.lista.push({ id: object.id, nombre: this.nombreCliente(object, object.id), marcado: true })
        }
        this.componentKey += 1
      },
      // Marca los clientes que hoy están en el grupo (no queda atado al grupo: si después se suman
      // clientes al grupo, hay que volver a marcarlo). Motivo con clientes puntuales: solo se pueden
      // marcar los del grupo que tienen el motivo, el resto se informa. Se aplica al Guardar.
      marcarGrupo() {
        var grupo = this.grupos.find(g => g.id == this.modal.clientes.grupoID)
        if(!grupo) {
          return
        }

        let loader = this.$loading.show();
        serviceAPI.obtenerClientesPorGrupo(grupo.id)
        .then((response) => {
          loader.hide()

          var paraTodos = this.ordersReason.available_all_customers
          var marcados = 0
          var sinMotivo = []

          response.data.forEach(customer => {
            var existente = this.modal.clientes.lista.find(c => c.id == customer.id)
            if(existente) {
              existente.marcado = true
              marcados++
            } else if(paraTodos) {
              this.modal.clientes.lista.push({ id: customer.id, nombre: this.nombreCliente(customer, customer.id), marcado: true })
              marcados++
            } else {
              sinMotivo.push(this.nombreCliente(customer, customer.id))
            }
          })
          this.modal.clientes.lista.sort((a, b) => a.nombre.localeCompare(b.nombre))

          if(!response.data.length) {
            this.$awn.warning('El grupo ' + grupo.name + ' no tiene clientes')
            return
          }
          // Un solo mensaje: el plugin está con maxNotifications: 1 y el segundo pisaría al primero
          var mensaje = marcados + ' cliente(s) de ' + grupo.name + ' marcados. Guardá para aplicar.'
          if(!sinMotivo.length) {
            this.$awn.success(mensaje)
            return
          }
          var nombres = sinMotivo.slice(0, 10).join(', ') + (sinMotivo.length > 10 ? ' y ' + (sinMotivo.length - 10) + ' más' : '')
          this.$awn.warning(mensaje + ' ' + sinMotivo.length + ' no tienen el motivo y no se marcaron: ' + nombres)
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      verClientes(data) {
        data.toggleDetails()
        var event = data.item
        if(this.detalleClientes[event.id]) {
          return
        }

        serviceAPI.obtenerClientesPorEvento(event.id)
        .then((response) => {
          var lista = response.data.map(item => {
            var grupo = item.customer ? this.grupos.find(g => g.id == item.customer.customers_group_id) : null
            return {
              id: item.customers_id,
              nombre: this.nombreCliente(item.customer, item.customers_id),
              grupo: grupo ? grupo.name : '',
            }
          })
          lista.sort((a, b) => a.nombre.localeCompare(b.nombre))
          this.$set(this.detalleClientes, event.id, lista)
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      marcarTodos(valor) {
        this.clientesFiltrados.forEach(c => { c.marcado = valor })
      },
      saveClientes() {
        let loader = this.$loading.show();
        var customers = this.clientesMarcados.map(c => c.id)

        serviceAPI.guardarClientesPorEvento(this.modal.clientes.event.id, customers)
        .then(() => {
          loader.hide()
          this.modal.clientes.active = false
          this.$awn.success("Datos guardados con éxito");
          this.load()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
    }
  }
</script>
